import * as React from "react";
import styles from "./ToggleButton.scss";

interface IProps {
    className?: string;
    onToggle: (newState: boolean) => void;
    state: boolean;
    children?: React.ReactNode[] | React.ReactNode;
}

const ToggleButton: React.FunctionComponent<IProps> = (props: IProps) => (
    <button className={`${styles.toggleButton} ${props.className} ${props.state ? styles.on : styles.off}`} onClick={() => props.onToggle(!props.state)}>
        {props.children}
    </button>
);

export default ToggleButton;


// WEBPACK FOOTER //
// ./src/Components/Common/ToggleButton/ToggleButton.tsx